import { create } from 'zustand';
import { Transaction } from '@/models/transaction';

type TransactionModalState = {
    isOpen: boolean;
    content?: Transaction;
    openModal: (content: Transaction) => void;
    closeModal: () => void;
};

export const useTransactionModalStore = create<TransactionModalState>(
    (set) => ({
        isOpen: false,
        content: undefined,
        openModal: (content: Transaction) => set({ isOpen: true, content }),
        closeModal: () => {
            console.log('login');
            set({ isOpen: false });
            // Clear the content after closing the modal
            setTimeout(() => {
                set({ content: undefined });
            }, 100);
        }
    })
);
